import GetStarted from "./get-started";
import Socials from "./socials";

const MarkettingBottomSection = ({ registerUrl }: any) => {

  return (
    <div className="marketing-bottom-section">
      <div className="pt-4 mt-4">
        <GetStarted registerUrl={registerUrl} />
        <Socials />
        <div className="marketing-copyright">
          Copyright © Film Tools Ltd 2020. All Rights Reserved. Company Registration 12507793. VAT GB 345 1054 29.
        </div>
      </div>
    </div>
  );
};

export default MarkettingBottomSection;
